<div class="content mx-auto mb-4">
  <span class="mb-3 lato">Play more and save with our packages!<br><br>
    Packages are location-specific and non-transferable. Be sure to confirm or adjust the location below before
    purchasing.
  </span>
</div>

<app-content-header
  text="Location"
  [showEdit]="true"
  (editClicked)="handleEditLocation()"
  firebase="package_changeCamperLocation"
></app-content-header>
<div class="location-tile-list-container mb-3">
  <app-location-tile
    [locationData]="orderRequest.selectedLocation"
    [isPreferred]="isPreferredLocation"
  ></app-location-tile>
</div>
<!-- <span *ngIf="orderRequest.selectedLocation; else elseBlock">
  <div class="location-tile-list-container mb-3">
    <app-location-tile
      [locationData]="orderRequest.selectedLocation"
      [isPreferred]="true"
    ></app-location-tile>
  </div>
</span>
<ng-template #elseBlock>
  <div class="location-tile-list-container mb-3">
    <app-location-tile
      [locationData]="myProfileService.preferredLocation$ | async"
      [isPreferred]="true"
    ></app-location-tile>
  </div>
</ng-template> -->

<!-- Package List -->
<app-content-header text="Packages"></app-content-header>
<div class="content mx-auto mb-4">
  <span *ngIf="isCcpEnabledInLocation" class="mb-3 lato">
    Other packages may be available. Contact Camp for the full menu of packages.
  </span>
  <div *ngIf="!isCcpEnabledInLocation" class="error-box alt p-15 text-center">
    <img
      height="24"
      width="24"
      src="../../../../assets/svg/ico_error_circle.svg"
    />
    <p class="error-box-text">
      You cannot purchase a package against a location that has not enabled the "Credit Card Processing" service.
    </p>
  </div>
</div>
<ng-container *ngIf="isCcpEnabledInLocation">
  <div
    class="location-tile-container"
    *ngFor="let packageItem of packageList"
  >
    <div class="mb-3">
      <app-package-item
        [packageItem]="packageItem"
        (toggleSelection)="togglePackageSelection($event)">
      </app-package-item>
    </div>
  </div>
</ng-container>

<!-- Button -->
<ng-container *ngIf="isCcpEnabledInLocation">
<hr class="bottom-divider" />
  <footer class="footer-action">
    <button
      class="btn btn-danger btn-block"
      [attr.disabled]="hasNoSelection() ? '' : null"
      (click)="proceed()"
    >Add to Cart</button>
  </footer>
</ng-container>
